import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function SubscriptionModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
}) {
  const [isOffer, setIsOffer] = useState(Boolean(data.offer_price));
  const [campuses, setCampuses] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await apiRequest({
        path: apiPaths.campuses,
      });
      if (res.error) {
        message.error(res.error_description);
        return;
      }
      setCampuses(res.results);
    })();
  }, []);

  return (
    <Modal
      title={isUpdate ? "Update Subscription Plan" : "Add Subscription Plan"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        initialValues={{
          is_active: true,
          ...data,
        }}
        onFinish={(values) => {
          onSave(values);
        }}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Plan Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Plan Name",
                },
              ]}
            >
              <Input placeholder="Plan Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Plan Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: "Please Plan Price",
                },
              ]}
            >
              <InputNumber style={{ width: 200 }} placeholder="Plan Price" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <div style={{ marginBottom: 15 }}>Subscription Type</div>
            <Radio.Group
              onChange={(e) => {
                setIsOffer(e.target.value);
              }}
              value={isOffer}
            >
              <Radio value={true}>Offer</Radio>
              <Radio value={false}>Plan</Radio>
            </Radio.Group>
          </Col>
          {isOffer ? (
            <Col span={8}>
              <Form.Item
                label="Offer Price"
                name="offer_price"
                rules={[
                  {
                    required: true,
                    message: "Please Offer price",
                  },
                ]}
              >
                <InputNumber style={{ width: 200 }} placeholder="price" />
              </Form.Item>
            </Col>
          ) : (
            <Col span={8}>
              <Form.Item
                label="Validity (days)"
                name="validity"
                rules={[
                  {
                    required: true,
                    message: "Please enter validity",
                  },
                ]}
              >
                <InputNumber style={{ width: 200 }} placeholder="days" />
              </Form.Item>
            </Col>
          )}
          {/* <Col span={8}>
            <Form.Item label="Status" name="is_active">
              <Radio.Group>
                <Radio value={true}>Active</Radio>
                <Radio value={false}>In-Active</Radio>
              </Radio.Group>
            </Form.Item>
          </Col> */}
        </Row>
        <Form.List name="uses">
          {(fields, { add, remove }) => (
            <div style={{ width: "100%" }}>
              <div style={{ marginBottom: 10 }}>Uses</div>
              {fields.map(({ key, name, ...restField }) => (
                <Row
                  key={key}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                >
                  <Col span={22}>
                    <Form.Item
                      {...restField}
                      name={[name, "note"]}
                      rules={[
                        {
                          required: true,
                          message: "Missing note",
                        },
                      ]}
                    >
                      <Input style={{ width: "90%" }} placeholder="type note" />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Col>
                </Row>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Add Use
                </Button>
              </Form.Item>
            </div>
          )}
        </Form.List>
        {!isUpdate ? (
          <Form.Item name="campuses" label="Select campuses">
            <Select mode="multiple" placeholder="Please select campuses">
              {campuses.map((campus) => (
                <Select.Option key={campus.id} value={campus.id}>
                  {campus.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        ) : null}
        {!isUpdate ? (
          <div style={{ color: "#a7a7a7" }}>
            NOTE: This subscription plan will be made active for selected
            campuses
          </div>
        ) : null}
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SubscriptionModal;
